// extracted by mini-css-extract-plugin
module.exports = {"showMoreButton":"ShowMoreButton_showMoreButton__zb4cp","showMoreIcon":"ShowMoreButton_showMoreIcon__JcwZx"};